import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import './statistics_content.css';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import Card from '../../../components/base/Card/Card';
import Sidebar from '../../../components/base/Sidebar/Sidebar';
import InfoCard from '../../../components/base/InfoCard/InfoCard';
// import SwotGrid from './SwotGrid';

// Add some styles for the local prova text display
const localProvaTextStyle = {
  padding: '20px 30px',
  backgroundColor: 'white',
  borderRadius: '8px',
  maxWidth: '90%',
  margin: '0 auto',
  textAlign: 'center',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  fontSize: '16px',
  lineHeight: '1.5'
};

function StatisticsContent() {
  const navigate = useNavigate();
  const [performance, setPerformance] = useState(null);
  const [simuladoDate, setSimuladoDate] = useState('');
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState('');
  const userID = localStorage.getItem('userID');
  const selectedSimuladoID = localStorage.getItem('selectedSimuladoID');
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [nullQuestions, setNullQuestions] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [cartaoRespostaUrl, setCartaoRespostaUrl] = useState('');
  const [localProvaUrl, setLocalProvaUrl] = useState('');
  const [localProvaIsUrl, setLocalProvaIsUrl] = useState(true);
  const [status, setStatus] = useState(0); // Status do simulado
  const [showStagesPopup, setShowStagesPopup] = useState(false);
  const [popupType, setPopupType] = useState(''); // 'cartao' or 'local'
  const [rankingEnable, setRankingEnable] = useState(false);
  const [examsEnable, setExamsEnable] = useState(false);
  const [cartaoRespostaEnable, setCartaoRespostaEnable] = useState(false)
  const [gabaritoEnable, setGabaritoEnable] = useState(false)
  const [gabaritoFile, setGabaritoFile] = useState(false)
  const [localProvaEnable, setLocalProvaEnable] = useState(false)
  const [showInscricaoPopup, setShowInscricaoPopup] = useState(false);
  const [inscritoSimulado, setInscritoSimulado] = useState(false);


  const popupRef = useRef(null);
  const stagesPopupRef = useRef(null);
  // Adicionar useRef para o popup de inscrição
  const inscricaoPopupRef = useRef(null);

  // Add new useEffect to handle simulado selection
  useEffect(() => {
    const fetchAndSelectSimulado = async () => {
      if (!userID) return;

      try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=get_simulados_by_aluno&ID_aluno=${userID}`);
        const simuladoData = await response.json();

        if (!simuladoData || !simuladoData.simulado_IDs || simuladoData.simulado_IDs.length === 0) {
          console.error('Nenhum simulado encontrado para o aluno');
          setLoading(false);
          return;
        }

        const simuladosData = simuladoData.simulado_IDs.map((id, index) => ({
          id,
          date: simuladoData.simulado_datas[index],
        }));

        let selectedSimulado;

        if (selectedSimuladoID) {
          selectedSimulado = simuladosData.find(simulado => simulado.id === selectedSimuladoID);
        }

        if (!selectedSimulado) {
          selectedSimulado = simuladosData[simuladosData.length - 1];
          localStorage.setItem('selectedSimuladoID', selectedSimulado.id);
        }

        // If we're still loading, we'll let the dashboard fetch handle setting loading to false
        if (!selectedSimuladoID) {
          window.location.reload(); // Reload to ensure the new selectedSimuladoID is used
        }
      } catch (error) {
        console.error('Erro ao buscar lista de simulados:', error);
        setLoading(false);
      }
    };

    fetchAndSelectSimulado();
  }, [userID, selectedSimuladoID]);

  const roundToOneDecimal = (number) => {
    return number && number !== -1 ? Number(number).toFixed(1).replace('.', ',') : '-';
  };

  const isUnavailable = (info) => info === '-';

  useEffect(() => {
    const fetchCartaoResposta = async () => {
      if (!userID || !selectedSimuladoID) return;

      try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=getCartaoResposta&ID_usuario=${userID}&ID_prova=${selectedSimuladoID}`);
        const data = await response.json();

        if (data.length > 0 && data[0].path_cartao_resposta) {
          setCartaoRespostaUrl(data[0].path_cartao_resposta);
        }
        else {
          setCartaoRespostaUrl("");
        }
      } catch (error) {
        console.error('Erro ao buscar o cartão resposta:', error);
      }
    };

    fetchCartaoResposta();
  }, [userID, selectedSimuladoID]);

  useEffect(() => {
    const fetchLocalProva = async () => {
      if (!userID || !selectedSimuladoID) return;

      try {
        
        const response = await fetch(`https://rvensino.com.br/get.php?action=get_local_prova&user_id=${userID}&exam_id=${selectedSimuladoID}`);
        const data = await response.text();
        console.log(data)
        

        // Local de prova is always text in this format, never an image URL
        if (data) {
          setLocalProvaUrl(data);
          setLocalProvaIsUrl(true); // Always set to false since it's always text
        } else {
          setLocalProvaUrl("");
          setLocalProvaIsUrl(false); 
        }
      } catch (error) {
        console.error('Erro ao buscar o local de prova:', error);
      }
    };

    fetchLocalProva();
  }, [userID, selectedSimuladoID]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
      if (stagesPopupRef.current && !stagesPopupRef.current.contains(event.target)) {
        setShowStagesPopup(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchDashboardData = async () => {
      if (!userID || !selectedSimuladoID) return;

      try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=dashboard&user_id=${userID}&exam_id=${selectedSimuladoID}`);
        const data = await response.json();
        console.log('dashboard data:')
        console.log(data)

        const storedUserName = localStorage.getItem('userName');

        if (storedUserName) {
          const firstName = storedUserName.split(' ')[0];
          setUserName(firstName);
        }

        if (data) {
          console.log(data);

          // Atualiza o status e data do simulado
          setStatus(data.exam_status);
          setSimuladoDate(data.exam_date);
          setRankingEnable(data.ranking_enable);
          setExamsEnable(data.exams_enable);
          
          setGabaritoFile(data.gabarito_file)

          // botoes: local de prova, cartão resposta, gabarito
          setLocalProvaEnable(data.exam_location_enable);
          console.log(`examLocationEnable ${data.exam_location_enable}`)
          setCartaoRespostaEnable(data.answer_card_enable);
          setGabaritoEnable(data.gabarito_enable)

          
          // Save exam_status, ranking_enable and exams_enable to localStorage for use in sidebar
          localStorage.setItem('examStatus', data.exam_status);
          localStorage.setItem('rankingEnable', data.ranking_enable);
          localStorage.setItem('examsEnable', data.exams_enable);


          // Atualiza os dados de questões diretamente da resposta
          setTotalQuestions(data.n_total);
          setNullQuestions(data.n_anuladas);

          // Atualiza o estado de performance para usar os novos dados
          setPerformance({
            Notas: {
              Media_sem_redacao: data.grade_without_essay,
              Media_com_redacao: data.grade_with_essay,
              Ciencias_Humanas: data.grade_humanas,
              Linguagens: data.grade_linguagens,
              Ciencias_Natureza: data.grade_natureza,
              Matematica: data.grade_matematica,
              Redacao: data.grade_redacao
            },
            Acertos: data.n_acertos,
            Erros: data.n_erros,
            Nulas: data.n_anuladas,
            TotalQuestoes: data.n_total,
            Classificacao_geral: data.overall_rating,
            Classificacao_grupo: data.class_rating
          });
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error('Erro ao buscar os dados do dashboard:', error);
      }
    };

    fetchDashboardData();
  }, [userID, selectedSimuladoID]);

  const handleOpenPopup = (type) => {
    setPopupType(type);
    setShowPopup(true);
  };

  const handleOpenGabarito = () => {
    // Replace this URL with your actual PDF URL when ready
    window.open(`https://rvensino.com.br/${gabaritoFile}`, '_blank');
  };

  if (loading) {
    return <div className='loading'>...</div>;
  }

  if (!performance) {
    return (
      <div className='page-container'>
        <div className='empty'>Suas performances de simulados aparecerão aqui</div>
      </div>
    );
  }

  const { Notas, Acertos, Classificacao_geral, Classificacao_grupo } = performance;

  return (
    <div>
      <div className={`content-container${showPopup || showStagesPopup || showInscricaoPopup ? ' blur' : ''}`}>
        <div className='content'>
          <div className='exam-link-container'>
            <p className="result-text"> Oi, {userName}! Confira aqui seus resultados: </p>
            
            <div className='simulado-info'>
              <span className="progress-text">Etapa: </span>
              <div className="simulado-progress" onClick={() => setShowStagesPopup(true)} style={{ cursor: 'pointer' }}>
                <div className="progress-bar">
                  <div className={`progress-fill stage-${status}`}></div>
                </div>
                <div className="progress-stages">
                  <span></span>
                  <span>1</span>
                  <span>2</span>
                  <span>3</span>
                  <span>4</span>
                  <span>5</span>
                </div>
              </div>

              <div className='exam dashboard-link'>
                <Link to="/historico" className="no-link-style"> Simulado realizado em {simuladoDate} </Link>
              </div>
            </div>
          </div>
          
          <div className='card-container'>
            {!rankingEnable ? (
              <div className='unavailable'>
                <div className='welcome-card unavailable card-inactive'>
                  <p className='welcome-message'>
                    Classificação geral: <span className='placing'>-</span>
                    <br />
                    Classificação do grupo: <span className='placing'>-</span>
                  </p>
                  <LeaderboardOutlinedIcon className='icon' style={{ fontSize: 65 }} />
                </div>
              </div>
            ) : (
              <Link to="/ranking" className='no-link-style'>
                <div className='welcome-card'>
                  <p className='welcome-message'>
                    Classificação geral: <span className='placing'>{Classificacao_geral === '-' ? '-' : `${Classificacao_geral}º`}</span>
                    <br />
                    Classificação do grupo: <span className='placing'>{Classificacao_grupo === '-' ? '-' : `${Classificacao_grupo}º`}</span>
                  </p>
                  <LeaderboardOutlinedIcon className='icon' style={{ fontSize: 65 }} />
                </div>
              </Link>
            )}
            <InfoCard title="Média sem redação" info={roundToOneDecimal(performance?.Notas?.Media_sem_redacao)} />
            <InfoCard title="Média com redação" info={roundToOneDecimal(performance?.Notas?.Media_com_redacao)} />
          </div>

          <div className='card-container'>
            {/* Card 1: Ciências Humanas e suas Tecnologias */}
            {!examsEnable ? (
              <div className='unavailable'>
                <Card unavailable title="Ciências Humanas e suas Tecnologias" info="-" icon="groups" />
              </div>
            ) : (
              // <Link 
              //   to="/detalhes" 
              //   state={{ expandedExam: 'CH' }} 
              //   className="no-link-style"
              // >
                <Card 
                  title="Ciências Humanas e suas Tecnologias" 
                  // por enquanto sempre unavailable
                  unavailable
                  //info={performance?.Notas?.Linguagens === 0 ? '-' : roundToOneDecimal(performance?.Notas?.Linguagens)} 
                  info={'-'} 
                  //info={performance?.Notas?.Ciencias_Humanas === 0 ? '-' : roundToOneDecimal(performance?.Notas?.Ciencias_Humanas)} 
                  icon="groups" 
                />
              // </Link>
            )}

            {/* Card 2: Linguagens, Códigos e suas Tecnologias */}
            {!examsEnable ? (
              <div className='unavailable'>
                <Card unavailable title="Linguagens, Códigos e suas Tecnologias" info="-" icon="chat" />
              </div>
            ) : (
              // <Link 
              //   to="/detalhes" 
              //   state={{ expandedExam: 'LC' }} 
              //   className="no-link-style"
              // >
                <Card 
                  title="Linguagens, Códigos e suas Tecnologias" 
                  // por enquanto sempre unavailable
                  unavailable
                  //info={performance?.Notas?.Linguagens === 0 ? '-' : roundToOneDecimal(performance?.Notas?.Linguagens)} 
                  info={'-'} 
                  icon="chat" 
                />
              // </Link>
            )}

            {/* Card 3: Ciências da Natureza e suas Tecnologias */}
            {!examsEnable ? (
              <div className='unavailable'>
                <Card unavailable title="Ciências da Natureza e suas Tecnologias" info="-" icon="bio" />
              </div>
            ) : (
              <Link 
                to="/detalhes" 
                state={{ expandedExam: 'CN' }} 
                className="no-link-style"
              >
                <Card 
                  title="Ciências da Natureza e suas Tecnologias" 
                  info={performance?.Notas?.Ciencias_Natureza === 0 ? '-' : roundToOneDecimal(performance?.Notas?.Ciencias_Natureza)} 
                  icon="bio" 
                />
              </Link>
            )}

            {/* Card 4: Matemática e suas Tecnologias */}
            {!examsEnable ? (
              <div className='unavailable'>
                <Card unavailable title="Matemática e suas Tecnologias" info="-" icon="functions" />
              </div>
            ) : (
              <Link 
                to="/detalhes" 
                state={{ expandedExam: 'MT' }} 
                className="no-link-style"
              >
                <Card 
                  title="Matemática e suas Tecnologias" 
                  info={performance?.Notas?.Matematica === 0 ? '-' : roundToOneDecimal(performance?.Notas?.Matematica)} 
                  icon="functions" 
                />
              </Link>
            )}

            {/* Card 5: Redação */}
            {!examsEnable ? (
              <div className='unavailable'>
                <Card unavailable title="Redação" info="-" icon="create" />
              </div>
            ) : (
              <Card 
                title="Redação" 
                // por enquanto sempre unavailable
                unavailable
                //info={performance?.Notas?.Linguagens === 0 ? '-' : roundToOneDecimal(performance?.Notas?.Linguagens)} 
                info={'-'} 
                //info={performance?.Notas?.Redacao === 0 ? '-' : roundToOneDecimal(performance?.Notas?.Redacao)} 
                icon="create"
              />
            )}
          </div>
          
          {/* <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <SwotGrid />
          </div> */}

          <div className='summary-container'>
            <div className='summary'>
              {/* Acertos */}
              <div className='info'>
                <p className='card-info' style={{ color: '#5faa5f' }}>
                  {cartaoRespostaUrl === '' 
                    ? '-' 
                    : performance?.Acertos}
                </p>
                <p className='card-title'>acertos</p>
              </div>

              {/* Erros */}
              <div className='info'>
                <p className='card-info' style={{ color: '#ff6767' }}>
                  {cartaoRespostaUrl === '' 
                    ? '-' 
                    : performance?.Erros}
                </p>
                <p className='card-title'>erros</p>
              </div>

              {/* Anuladas */}
              <div className='info'>
                <p className='card-info' style={{ color: '#909090' }}>
                  {cartaoRespostaUrl === '' 
                    ? '-' 
                    : performance?.Nulas}
                </p>
                <p className='card-title'>anuladas</p>
              </div>

              {/* Total de questões */}
              <div className='info'>
                <p className='card-info'>
                  {cartaoRespostaUrl === '' 
                    ? '-' 
                    : performance?.TotalQuestoes}
                </p>
                <p className='card-title'>total</p>
              </div>

              {/* Local de Prova Button */}
              <div className='info prova'>
                <button
                  className={`open-popup-button-statistics ${!localProvaEnable ? 'disabled' : ''}`}
                  onClick={() => navigate('/local-de-prova')}
                  disabled={!localProvaEnable}
                >
                  local de prova
                </button>
              </div>

              {/* Cartão Resposta Button */}
              <div className='info'>
                <button
                  className={`open-popup-button-statistics ${!cartaoRespostaEnable ? 'disabled' : ''}`}
                  onClick={() => cartaoRespostaEnable ? handleOpenPopup('cartao') : null}
                  disabled={!cartaoRespostaEnable}
                >
                  cartão-resposta
                </button>
              </div>

              {/* Gabarito Completo Button */}
              <div className='info pdf'>
                <button
                  className={`open-popup-button-statistics ${!gabaritoEnable ? 'disabled' : ''}`}
                  onClick={handleOpenGabarito}
                  disabled={!gabaritoEnable}
                  >
                  gabarito completo
                </button>
              </div> 

              {/* Botão de inscrição para o próximo simulado 
              <div className='info inscricao'>
                <button
                  className={`inscricao-simulado-btn${inscritoSimulado ? ' inscrito' : ''}`}
                  onClick={() => setShowInscricaoPopup(true)}
                >
                  {inscritoSimulado ? 'Próximo Simulado' : 'Próximo Simulado'}
                </button>
              </div>
            */}

            </div>
          </div>
        </div>
      </div>

      {/* Popup for both Cartão Resposta and Local de Prova */}
      <div>
        {showPopup && (
          <div className={`popup-overlay-statistics ${popupType}`} ref={popupRef}>
            {popupType === 'cartao' ? (
              <div className="cartao-resposta-container">

              <div className='close-button-container cartao'>
                <button
                  className='close-popup-statistics'
                  onClick={() => setShowPopup(false)}
                  >
                  X
                </button>
              </div>

              <img
                src={cartaoRespostaUrl}
                alt="Cartão Resposta"
                className='popup-image-statistics'
              />

              </div>

            ) : (
              <div className="local-prova-text" style={localProvaTextStyle}>

                <div className='close-button-container'>
                  <button
                    className='close-popup-statistics'
                    onClick={() => setShowPopup(false)}
                    >
                    X
                </button>
                </div>

                <h3 style={{marginBottom: '15px', color: '#333', fontSize: '22px'}}>Local de Prova</h3>
                <p style={{fontSize: '18px'}}>{localProvaUrl}</p>


              </div>
            )}
            
          </div>
        )}
      </div>

      {/* Stages Popup */}
      <div>
        {showStagesPopup && (
          <div className="popup-overlay-statistics etapas" ref={stagesPopupRef}>
            <div className="popup-content-stages">
              <div className='stages-text'> 
                
                <div className='close-button-container etapa'> 

                  <button
                    className="close-popup-statistics stages"
                    onClick={() => setShowStagesPopup(false)}
                  >
                    X
                  </button>

                </div>

                <h3>Etapas do Simulado</h3>
                <div className='stages-explanation'> 
                  <p>1. Liberação do Simulado</p>
                  <p>2. Divulgação do Cartão-Resposta</p>
                  <p>3. Análise de Recursos</p>
                  <p>4. Correção das Questões</p>
                  <p>5. Cálculo das Notas</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Popup de inscrição do próximo simulado */}
      <div>
        {showInscricaoPopup && (
          <div className="popup-overlay-statistics etapas">
            <div className="popup-content-stages" ref={inscricaoPopupRef}>
              <div className='stages-text'>
                <h2 style={{marginBottom: '10px'}}>Próximo Simulado</h2>
                <div className="inscricao-info">
                  <p><b>Nome:</b> Simulado Nacional RV</p>
                  <p><b>Data:</b> 30/06/2024</p>
                  <p><b>Horário:</b> 13:00</p>
                  <p><b>Regras:</b> Compareça com documento oficial, caneta preta, e chegue com 30 minutos de antecedência.</p>
                </div>
                <button
                  className={`inscricao-simulado-btn${inscritoSimulado ? ' inscrito' : ''}`}
                  onClick={() => { setInscritoSimulado(true); setShowInscricaoPopup(false); }}
                  style={{marginTop: '20px'}}
                >
                  {inscritoSimulado ? 'Inscrição Efetuada para o Próximo Simulado!' : 'Inscrever-se'}
                </button>
              </div>
              <button
                className="close-popup-statistics inscricao"
                onClick={() => setShowInscricaoPopup(false)}
              >
                X
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default StatisticsContent;
